import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { Button } from '@/shared/ui';

type Props = {
  onBack: () => void;
  ariaLabel?: string;
};

export const BackButton = ({ onBack, ariaLabel }: Props) => {
  return (
    <Button variant="non-outline" size="none" onClick={onBack} aria-label={ariaLabel}>
      <ArrowLeftIcon />
    </Button>
  );
};
